import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  EventLogReqObj,
  EventLogRespObj,
} from '@/api/models';

export async function getEventLog(
  req: EventLogReqObj,
): Promise<EventLogRespObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/EventLog',
    req,
  );
  return unwrapContainer<EventLogRespObj>(response.data);
}
